import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useUpdateCompany = () => {
  const mutation = useMutation((formData) => {
    return axiosClient.put("/Company/UpdateCompany", formData);
  });
  return mutation;
};
export default useUpdateCompany;
